import { featuredCollections } from '@/mocks/collections';

export default function FeaturedCollections() {
  return (
    <section id="collections" className="bg-white py-20 md:py-28 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-12 md:mb-16 gap-4">
          <div>
            <span className="block font-sans-body text-[1rem] text-gold-500 tracking-widest mb-3 font-medium">
              FEATURED COLLECTIONS
            </span>
            <h2 className="font-serif-title text-[1.5rem] md:text-[2.125rem] text-warm-900 font-semibold leading-[1.4]">
              精選穿搭系列
            </h2>
          </div>
          <p className="font-sans-body text-[1.1875rem] text-warm-900/60 leading-[1.75] md:max-w-xs">
            每週更新品項，精選各大品牌當季款式
          </p>
        </div>

        {/* Collections Grid */}
        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8"
          data-product-shop
        >
          {featuredCollections.map((col) => (
            <div
              key={col.id}
              className="group relative overflow-hidden rounded-2xl border border-cream-200 bg-cream-50 cursor-pointer"
            >
              {/* Image */}
              <div className="relative w-full h-[420px] md:h-[480px] overflow-hidden">
                <img
                  src={col.image}
                  alt={col.label}
                  title={`${col.label} - 台中女裝Outlet`}
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>

              {/* Info */}
              <div className="p-6 md:p-7 bg-white">
                <p className="font-sans-body text-[1rem] text-gold-500 tracking-wider mb-1 font-medium">
                  {col.subtitle}
                </p>
                <h3 className="font-serif-title text-[1.25rem] md:text-[1.625rem] text-warm-900 font-semibold leading-[1.5] mb-1">
                  {col.label}
                </h3>
                <p className="font-sans-body text-[1rem] text-warm-900/55 mb-4">
                  {col.desc}
                </p>
                <div className="flex items-center justify-between">
                  <span className="font-sans-body text-[1rem] text-warm-900/50">
                    {col.count} 件商品
                  </span>
                  <button className="whitespace-nowrap flex items-center gap-1.5 text-[1rem] font-medium text-warm-900 hover:text-gold-500 transition-colors cursor-pointer">
                    查看系列
                    <span className="w-5 h-5 flex items-center justify-center">
                      <i className="ri-arrow-right-line text-base"></i>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
